import type { MenuItem, MenuItemGroup, MenuItemLeaf } from "./types";

export function isMenuItemGroup(item: MenuItem): item is MenuItemGroup {
  return (
    !!item &&
    typeof item === "object" &&
    Array.isArray((item as MenuItemGroup).items)
  );
}

export function isMenuItemLeaf(item: MenuItem): item is MenuItemLeaf {
  return (
    !!item &&
    typeof item === "object" &&
    typeof (item as MenuItemLeaf).href === "string" &&
    !("items" in item)
  );
}
